<template>
  <div class="manage-category">
    <el-row type="flex" align="middle" justify="space-between" class="mb-l">
      <el-row type="flex" align="middle" class="page-title">
        <i class="el-icon-menu mr-s" />
        <h3>Quản lý bài viết</h3>
      </el-row>
      <el-button type="primary" @click="$router.push({ name: 'CreatePosts' })">
        Thêm
      </el-button>
    </el-row>
    <el-form :model="form" inline ref="form">
      <el-form-item>
        <el-input
          v-model="form.name"
          @input="handleSearchPosts"
          clearable
          placeholder="Tìm kiếm bài viết"
          class="search mb-xl"
        />
      </el-form-item>
      <!-- <el-form-item>
        <el-select
          v-model="form.category_id"
          @change="handleSearchPosts"
          clearable
          filterable
          style="width: 300px"
          placeholder="Tìm theo topic"
        >
          <el-option
            v-for="item in categories"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          />
        </el-select>
      </el-form-item> -->
    </el-form>
    <el-row type="flex" justify="end">
      <el-button
        size="medium"
        type="primary"
        class="mb-m"
        @click="handleRefreshData"
      >
        <i class="el-icon-refresh"></i>
      </el-button>
    </el-row>
    <el-table :data="postses" border v-loading="callingAPI">
      <el-table-column label="#" type="index" align="center" width="50px" />
      <el-table-column label="Tên bài viết" min-width="200px">
        <template slot-scope="scope"> {{ scope.row.name }} </template>
      </el-table-column>
      <el-table-column label="Loại">
        <template slot-scope="scope">
          {{ scope.row.category_name }}
        </template>
      </el-table-column>
      <el-table-column label="Tên tác giả" min-width="120px">
        <template slot-scope="scope"> {{ scope.row.author }} </template>
      </el-table-column>
      <el-table-column label="Ngày xuất bản" width="120px">
        <template slot-scope="scope">
          {{ scope.row.published_at | convertDate }}
        </template>
      </el-table-column>
      <el-table-column label="Head news" width="100px" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.head_new"
            @change="handleUpdatePosts(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="Sửa" align="center" width="70px" fixed="right">
        <template slot-scope="scope">
          <el-button
            plain
            size="small"
            @click="
              $router.push({
                name: 'UpdatePosts',
                params: { id: scope.row.id },
              })
            "
            icon="el-icon-edit"
            circle
          />
        </template>
      </el-table-column>
      <el-table-column label="Xoá" align="center" width="70px" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="small"
            @click="handleRemovePosts(scope.row)"
            icon="el-icon-delete"
            circle
          />
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" class="mt-m">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        @current-change="handleChangePage"
      />
    </el-row>
  </div>
</template>

<script>
import { fetchCategory } from "@/services/category";
import { searchPosts, updatePosts, deletePosts } from "@/services/posts";
export default {
  name: "ManagePosts",
  data() {
    return {
      callingAPI: false,
      debounce: null,

      name: "",
      page: 1,
      total: 0,
      pageSize: 10,

      postses: [],
      categories: [],

      form: {
        name: "",
        category_id: "",
      },
    };
  },
  async beforeMount() {
    await this.loadCategories();
    await this.loadData();
  },
  methods: {
    async handleRefreshData() {
      this.$refs.form.resetFields();
      await this.loadData();
    },

    async loadCategories() {
      try {
        this.callingAPI = true;
        const response = await fetchCategory();
        this.categories = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async loadData(page = null) {
      try {
        this.callingAPI = true;
        const params = {
          name: this.form.name,
          category_id: this.form.category_id,
          page: page ? page : 1,
          limit: this.pageSize,
        };
        const response = await searchPosts(params);
        this.postses = response.data.posts.map((p) => ({
          ...p,
          head_new: p.head_new === 1,
        }));
        this.total = response.data.paginate.total;
        this.callingAPI = false;
      } catch (error) {
        console.log(error);
        this.callingAPI = false;
      }
    },

    async handleChangePage(page) {
      this.page = page;
      await this.loadData(page);
    },

    async handleSearchPosts() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        await this.loadData();
      }, 500);
    },

    async handleUpdatePosts(row) {
      const data = {
        ...row,
        head_new: row.head_new ? 1 : null,
      };
      delete data.id;
      await updatePosts(row.id, data);
    },

    async handleRemovePosts(row) {
      this.$confirm(`Chắc chắn muốn xoá bài viết ${row.name} ?`, "Warning", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      })
        .then(async () => {
          try {
            this.callingAPI = true;
            await deletePosts(row.id);
            await this.loadData(this.page);
            this.$notify.success({
              title: "Thành công",
              message: `Xoá bài viết ${row.name} thành công.`,
              duration: 2000,
            });
          } catch (error) {
            this.callingAPI = false;
            this.$notify.error({
              title: "Thất bại",
              message: "Xoá bài viết thất bại.",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },

    currentCategory(category_id) {
      if (this.categories.find((c) => c.id == category_id)) {
        return this.categories.find((c) => c.id == category_id);
      }
      return null;
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
</style>
